import TZDate from 'lib/TZDate';

export function formatInterval(start : TZDate, end : TZDate) {
    var msecs = +end - +start,
        mins = Math.floor(Math.abs(msecs) / 60 / 1000),
        hrs = Math.floor(mins / 60),
        minsRemainder = mins % 60;

    var signText = msecs < 0 ? 'neg. ' : '',
        hrsText = hrs ? hrs + ' hr ' : '',
        minsText = minsRemainder || !hrs ? minsRemainder + ' min' : '';

    return (signText + hrsText + minsText).trim();
}


// WEBPACK FOOTER //
// ./lib/formatInterval.ts